export default __webpack_public_path__ + "static/media/show-more.7f9ab25d.svg";